import React, { useState } from "react";
import WhatsNewButton from "./WhatsNewButton";
import WhatsNewDrawer from "./WhatsNewDrawer";
import { useWhatsNew } from "./useWhatsNew";
import "./WhatsNew.scss";

// The header's "What's new": a badge with the number of releases the user has not seen yet,
// and a drawer with the release notes. Notes are written in the back-office.
const WhatsNew: React.FC = () => {
  const [show, setShow] = useState(false);
  const { count, notes, loading, failed, loadNotes, markRead } = useWhatsNew();

  const open = () => {
    setShow(true);
    loadNotes();
  };

  return (
    <>
      <WhatsNewButton count={count} onClick={open} />
      <WhatsNewDrawer
        show={show}
        onHide={() => setShow(false)}
        notes={notes}
        loading={loading}
        failed={failed}
        onRetry={loadNotes}
        onRead={markRead}
      />
    </>
  );
};

export default WhatsNew;
